module.exports = __webpack_public_path__ + "static/media/1417940930.2fd10943.ttf";